export const BaseGray = "#6f788d";
export const ErrorRed = "#ea706b";
export const SubmittedGreen = "#4dc06b";

export const ImportantWarnRed = "#f25a54";
export const UnimportantWarnOrange = "#ffa16c";

export const CitizenBlue = "#63aaf8";
export const MafiaRed = "#f46659";
